/**
 * @p5doc module
 * @name config
 *
 * @description
 * # MODULE_TITLE
 *
 * MODULE_DESCRIPTION.
 */

export const currency = VDConfig.currencies;
export const csrfToken = VDConfig.csrfToken;
export const minAvgPriceChartResults = VDConfig.minAvgPriceChartResults;
export const minPriceVsOdoChartsResults = VDConfig.minPriceVsOdoChartsResults;
export const recaptchaSiteKeyV2 = VDConfig.recaptchaSiteKeyV2;
export const recaptchaSiteKeyV3 = VDConfig.recaptchaSiteKeyV3;